<form (ngSubmit)="send()" [formGroup]="form" class="form-horizontal">
  <div *ngFor="let field of fields">
    <app-fieldbuilder [field]="field" [form]="form"></app-fieldbuilder>
  </div>
  <div class="form-row"></div>
  <div class="form-group row">
    <div class="col-md-3"></div>
    <div class="col-md-9">
      <button type="submit" [disabled]="!form.valid" class="btn btn-primary">Save</button>
     </div>
  </div>
</form>
